import React from 'react';
import Translate from 'react-translate-component';

export const PersonSourceForSys = ({ sourceForSys }) => (sourceForSys) ? (
    <dl className="dl-horizontal">
        <Translate content="user.settings.tables.project_worksheet.sourceForSys" component="dt" />
        <dd>{ sourceForSys }</dd>
    </dl>
) : null;
